import React, { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL;

// Single-select of product families, sourced from product metadata
// (/product-families). value = familyKey string. A legacy value not in the
// catalogue is preserved as an option so editing never silently drops it.
export default function ProductFamilyPicker({ value, onChange, getToken, placeholder = 'Select product family…' }) {
  const [families, setFamilies] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await getToken();
        const res = await window.fetch(`${API_BASE}/product-families`, { headers: { Authorization: `Bearer ${token}` } });
        const d = await res.json();
        if (!cancelled && d.ok) setFamilies(d.items || []);
      } catch { /* leave empty — keeps whatever value is set */ }
    })();
    return () => { cancelled = true; };
  }, [getToken]);

  const inp = {
    background: 'var(--ni-panel)', border: '1px solid var(--ni-border-soft)', color: 'var(--ni-text)',
    borderRadius: 6, padding: '8px 12px', fontSize: 13, width: '100%', boxSizing: 'border-box',
  };
  const label = (f) => {
    const dn = f.profile && f.profile.displayName;
    const base = dn && dn !== f.familyKey ? `${dn} (${f.familyKey})` : f.familyKey;
    return f.productCount ? `${base} · ${f.productCount}` : base;
  };
  const known = families.some(f => f.familyKey === value);

  return (
    <select value={value || ''} onChange={e => onChange(e.target.value)} style={inp}>
      <option value="">{placeholder}</option>
      {value && !known && <option value={value}>{value}</option>}
      {families.map(f => <option key={f.familyKey} value={f.familyKey}>{label(f)}</option>)}
    </select>
  );
}
